var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "base-switch" }, [
    _c(
      "div",
      { staticClass: "base-switch__list" },
      _vm._l(_vm.options, function ([option, index]) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "base-switch__item",
            class: { "is-active": option === _vm.value },
            on: {
              click: function ($event) {
                return _vm.handleChange(option)
              },
            },
          },
          [
            _c("div", { staticClass: "base-switch__control" }, [
              _c(
                "span",
                { staticClass: "base-switch__label" },
                [
                  _vm._t("default", function () {
                    return [_vm._v(_vm._s(option))]
                  }),
                ],
                2
              ),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }